<template>
  <div class="buildings-page">

    <!-- Hero banner -->
    <page-hero
        class="mb-1"
        :title="msg('Buildings')"
        :subtitle="msg('Manage buildings and their configurations')"
        variant="building"
        :stats="[{ icon: 'BuildingIcon', value: page.total, label: msg('total') }]"
    >
      <template #illustration>
        <svg viewBox="0 0 100 120" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="20" y="40" width="60" height="65" rx="4" fill="rgba(255,255,255,.15)" stroke="rgba(255,255,255,.25)" stroke-width="1.5"/>
          <rect x="30" y="55" width="12" height="12" rx="1" fill="rgba(255,255,255,.3)"/>
          <rect x="46" y="55" width="12" height="12" rx="1" fill="rgba(255,255,255,.25)"/>
          <rect x="62" y="55" width="12" height="12" rx="1" fill="rgba(255,255,255,.3)"/>
          <rect x="30" y="73" width="12" height="12" rx="1" fill="rgba(255,255,255,.25)"/>
          <rect x="46" y="73" width="12" height="12" rx="1" fill="rgba(255,255,255,.35)"/>
          <rect x="62" y="73" width="12" height="12" rx="1" fill="rgba(255,255,255,.2)"/>
          <path d="M50 20v20" stroke="rgba(255,255,255,.3)" stroke-width="2"/>
          <circle cx="50" cy="15" r="6" fill="rgba(255,255,255,.25)"/>
          <circle cx="78" cy="25" r="8" fill="rgba(255,255,255,.08)"/>
          <circle cx="8" cy="90" r="10" fill="rgba(255,255,255,.06)"/>
        </svg>
      </template>
    </page-hero>

    <!--Breadcrumb button-->
    <breadcrumb-buttons hide-settings>
      <template #default>
        <div class="flex-container">

          <b-button id="import-from-hostaway-button" variant="primary" class="btn-icon" v-b-tooltip
                    v-bind:title="msg('Import Building from External channel manager')">
            <i class="fa-solid fa-cloud-arrow-down"></i>
          </b-button>

        </div>

      </template>
    </breadcrumb-buttons>

    <!--Fetch from hostaway popover-->
    <b-popover size="xl" target="import-from-hostaway-button" triggers="click" placement="bottom"
               @show="dismissAllPopovers" class="crm-popover">
      <template #title>{{ msg("Import Building from External channel manager") }}</template>
      <div class="crm-popover-body" style="max-width: 800px; min-width: 500px">
        <div class="mb-1">
          <v-select
              :dir="isRTL ? 'rtl' : 'ltr'"
              v-model="hostawayBuid"
              placeholder="Branch"
              :options="allBranches"
              class="w-100"
              label="name"
              :reduce="(branch) => branch.id"
              :clearable="false"

          />
        </div>
        <b-button block :disabled="hostawayBuid == null || fetchListLoading" class="text-nowrap" variant="warning"
                  v-b-tooltip @click="fetchListFromExternal">
          <i v-if="fetchListLoading" class="fas fa-spinner fa-spin mr-1"></i> <!-- Spinner -->
          <i v-else class="fas fa-list mr-1"></i> <!-- Icon -->
          <span v-if="fetchListLoading">Loading...</span> <!-- Loading text -->
          <span v-else>Fetch list</span> <!-- Default text -->
        </b-button>

      </div>
    </b-popover>
    <!--Filters-->
    <b-card no-body class="filters-card mb-3">
      <b-card-header class="pb-50">
        <b-row no-gutters class="w-100">
          <b-col>
            <h5>{{ msg("Filters") }}</h5>
          </b-col>
          <b-col>
            <div class="d-flex justify-content-end">
              <b-link style="color: inherit" @click="refresh()">
                <feather-icon icon="RefreshCcwIcon" size="16"/>
              </b-link>
            </div>
          </b-col>
        </b-row>
      </b-card-header>
      <b-card-body>
        <b-row>


          <b-col cols="12" md="4" class="mb-md-0 mb-2">
            <label>{{ msg("Id") }}</label>
            <b-form-input
                v-model="filter.like.id"
                class="d-inline-block mr-1"
            />
          </b-col>
          <b-col cols="12" md="4" class="mb-md-0 mb-2">
            <label>{{ msg("Company") }}</label>
            <b-form-input
                v-model="filter.like.company"
                class="d-inline-block mr-1"
            />
          </b-col>
          <b-col cols="12" md="4" class="mb-md-0 mb-2">
            <label>{{ msg("Address") }}</label>
            <b-form-input
                v-model="filter.like.address"
                class="d-inline-block mr-1"
            />
          </b-col>

          <!-- Type-->
          <b-col cols="12" md="4" class="mb-md-0 mb-2">
            <label>{{ msg("Zip") }}</label>
            <b-form-input
                v-model="filter.like.zip"
                class="d-inline-block mr-1"
            />
          </b-col>

          <b-col cols="12" md="4" class="mb-md-0 mb-2">
            <label>{{ msg("Location") }}</label>
            <b-form-input
                v-model="filter.like.location"
                class="d-inline-block mr-1"
            />
          </b-col>
          <b-col cols="12" md="4" class="mb-md-0 mb-2">
            <label>{{ msg("Usage") }}</label>
            <b-form-input
                v-model="filter.like.usage"
                class="d-inline-block mr-1"
            />
          </b-col>
          <b-col cols="12" md="4" class="mb-md-0 mb-2">
            <label>{{ msg("Total Space") }}</label>
            <b-form-input
                v-model="filter.like.space"
                class="d-inline-block mr-1"
            />
          </b-col>


          <b-col cols="12" md="6" lg="4">

            <b-form-group :label="msg('Bank')" label-for="realEstate-branch">
              <v-select
                  :dir="isRTL ? 'rtl' : 'ltr'"
                  :clearable="true"
                  v-model="filter.in.activeBanksIds"
                  :options="allBanks"
                  class="w-100"
                  label="name"
                  :reduce="(bank) => bank"

              />
            </b-form-group>
          </b-col>

          <b-col cols="12" md="6" lg="4">

            <b-form-group :label="msg('Refinanced')" label-for="realEstate-branch">
              <v-select
                  :dir="isRTL ? 'rtl' : 'ltr'"
                  :clearable="true"
                  v-model="filter.eq.isRefinanced"
                  label="label"
                  :options="[{value: null,label:msg('All')},{value:true,label:msg('Refinanzierung gesendet')}]"
                  class="w-100"
                  :reduce="(type) => type.value"

              />
            </b-form-group>
          </b-col>

          <b-col cols="12" md="4" class="mb-md-0 mb-2">
            <label>{{ msg("Interest") }} bigger than </label>
            <b-form-input
                v-model="filter.gte.interest"
                class="d-inline-block mr-1"
            />
          </b-col>


          <b-col cols="12" md="4" class="mb-md-0 mb-2">
            <label>{{ msg("Interest") }} less than </label>
            <b-form-input
                v-model="filter.lte.interest"
                class="d-inline-block mr-1"
            />
          </b-col>


          <!--featured status-->
          <b-col cols="12" md="4" class="mb-md-0 mb-2">
            <b-form-group :label="msg('Status')" label-for="realEstate-branch">
              <v-select
                  :dir="isRTL ? 'rtl' : 'ltr'"
                  :clearable="true"
                  v-model="filter.eq.status"
                  :options="allStatuses"
                  class="w-100"
                  label="text"
                  :reduce="(branch) => branch.value"

              />
            </b-form-group>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
    <!-- Import card: Buildings & Clients -->
    <b-card no-body class="import-card mb-3">
      <b-card-body class="py-3 px-3">
        <div class="import-card-inner">
          <!-- Buildings import -->
          <div class="import-section">
            <div class="import-section-label">
              <i class="far fa-building text-primary mr-1"></i>
              <span>{{ msg("Upload") }} {{ msg("Buildings") }}</span>
            </div>
            <div class="import-section-controls">
              <b-button size="sm" variant="outline-primary" v-b-tooltip
                        :title="msg('Click here to download the buildings excel template')"
                        @click="downloadExcelTemplate">
                <i class="far fa-file-excel mr-1"></i>
                {{ msg('Template') }}
              </b-button>
              <b-button size="sm" variant="outline-secondary" @click="resetFile">{{ msg('Reset') }}</b-button>
              <v-select
                  :dir="isRTL ? 'rtl' : 'ltr'"
                  v-model="buid"
                  placeholder="Branch"
                  :options="allBranchesForUpload"
                  class="import-select"
                  label="name"
                  :reduce="(branch) => branch.id"
                  :clearable="false"
                  append-to-body
              />
              <b-form-file
                  v-if="buid!=null"
                  v-model="file"
                  size="sm"
                  class="import-file"
                  :placeholder="msg('Drop building excel...')"
                  :drop-placeholder="msg('Drop file...')"
              />
            </div>
          </div>
          <!-- Clients import -->
          <div class="import-section" v-if="buildings!=null && buildings.length>0">
            <div class="import-section-label">
              <i class="far fa-users text-info mr-1"></i>
              <span>{{ msg('Import') }} {{ msg('Clients') }}</span>
            </div>
            <div class="import-section-controls">
              <b-button size="sm" variant="outline-primary" v-b-tooltip
                        :title="msg('Click here to download the client excel template')"
                        @click="downloadExcelTemplateClients">
                <i class="far fa-file-excel mr-1"></i>
                {{ msg('Template') }}
              </b-button>
              <b-button size="sm" variant="outline-secondary" @click="resetFileClients">{{ msg('Reset') }}</b-button>
              <v-select
                  placeholder="Building"
                  :dir="isRTL ? 'rtl' : 'ltr'"
                  v-model="buildingId"
                  :options="buildings"
                  class="import-select"
                  label="address"
                  :reduce="(building) => building.id"
                  append-to-body
              />
              <b-form-file
                  v-if="buildingId!=null"
                  v-model="fileClient"
                  size="sm"
                  class="import-file"
                  :placeholder="msg('Drop client excel...')"
                  :drop-placeholder="msg('Drop file...')"
              />
            </div>
          </div>
        </div>
      </b-card-body>
    </b-card>
    <b-card no-body class="table-card mb-0">
      <div class="card-header" style="overflow: hidden">
        <span class="card-title m-0">{{ msg('Buildings') }}</span>
        <b-col>
          <div class="d-flex justify-content-end">
            <b-link style="color: inherit" @click="refresh()">
              <feather-icon icon="RefreshCcwIcon" size="16"/>
            </b-link>
          </div>
        </b-col>
      </div>
      <!--Card Content-->
      <b-card-body class="pb-0 px-3">
        <b-row no-gutters class="mb-3">
          <b-col cols="12" md="6" class="d-flex align-items-center mb-2 mb-md-0">
            <label class="mr-2">{{ msg('Show') }}</label>
            <v-select
                v-model="page.amount"
                @option:selected="refresh"
                :options="[10,25,50,100]"
                :clearable="false"
                class="per-page-selector mr-2"
                :dir="isRTL?'rtl':'ltr'"
            />
            <label>{{ msg('entries') }}</label>
          </b-col>
          <b-col cols="12" md="6">
            <div class="d-flex justify-content-end align-items-center">
              <b-form-input
                  v-model="filter.like.search"
                  class="mr-2"
                  :placeholder="msg('Search')"
              />
              <b-button variant="primary" @click="onBuildingSelect(0)">
                {{ msg('New building') }}
              </b-button>
            </div>
          </b-col>
        </b-row>
      </b-card-body>

      <!-- Cards -->
      <b-container fluid class="px-3">
        <b-row>
          <b-col
              v-for="item in buildings"
              :key="item.id"
              cols="12" sm="6" md="4" lg="3"
              class="mb-4"
          >
            <b-card
                :class="[
          'building-card',
          item.active ? 'active-highlight' : 'not-active-highlight',
          'shadow-3d', 'h-100', 'd-flex', 'flex-column'
        ]"

            >
              <!-- Rounded Top Image -->
              <div class="card-image-wrapper">
                <b-img
                    v-if="item.attachments && item.attachments.length"
                    :src="mergeSrcUrl(getRealEstatesWebSite, item.attachments[0])"
                    fluid
                    class="card-image rounded-top"
                />
                <div v-else class="image-placeholder rounded-top d-flex flex-column align-items-center justify-content-center">
                  <i class="far fa-building text-muted mb-2" style="font-size: 4rem; opacity: 0.5"></i>
                  <span class="text-muted small">{{ msg('No image') }}</span>
                </div>
              </div>

              <!-- Body -->
              <b-card-body class="p-3 flex-fill d-flex flex-column">
                <!-- Active & Updated -->
                <div class="d-flex justify-content-between align-items-center mb-2">
                  <b-badge
                      :variant="item.active ? 'success' : 'danger'"
                      class="text-capitalize"
                  >
                    {{ item.active ? msg('Active') : msg('Inactive') }}
                  </b-badge>
                  <small class="text-muted">
                    {{ msg('Updated at') }}<br>
                    {{
                      $moment(item.updatedDate, 'YYYY-MM-DD HH:mm')
                          .format('DD/MM/YY HH:mm')
                    }}
                  </small>
                </div>

                <!-- Company & Address -->
                <h5 class="company-name mb-1">{{ item.company }}</h5>
                <p class="address mb-3">{{ item.address }}</p>

                <!-- Invoices, Units -->
                <div class="d-flex flex-wrap">
                  <div class="mr-3 mb-1">
                    <strong>{{ msg('Open Invoices') }}:</strong>
                    <b-badge
                        :variant="getBadgeVariant(getCountOfOpenInvoices(item.buildingInvoices))"
                        class="ml-2"
                    >
                      {{ getCountOfOpenInvoices(item.buildingInvoices) }}
                    </b-badge>
                  </div>
                  <div class="mr-3 mb-1">
                    <strong>{{ msg('Units') }}:</strong>
                    <b-badge
                        variant="dark"
                        class="ml-2"
                    >
                      {{ item.propertyIds ? item.propertyIds.length : 0 }}
                    </b-badge>
                  </div>
                </div>

                <!-- Offer Template -->
                <div>
                  <strong>{{ msg('Template') }}:</strong>
                  <i
                      :class="[
                item.offerTemplateIds ? 'fas fa-check text-success' : 'fas fa-warning text-danger',
                'ml-2'
              ]"
                  ></i>
                </div>


              </b-card-body>
              <!-- Footer with full-width buttons -->
              <b-card-footer class="p-2">
                <b-button
                    block
                    variant="primary"
                    size="sm"

                    class="flex-fill"
                    @click.stop="onRowClick(item)"
                >
                  {{ msg('Edit') }}
                </b-button>
                <b-button
                    block
                    :disabled="item.propertyIds!=null&& item.propertyIds.length>0"
                    size="sm"
                    variant="danger"
                    class="flex-fill"
                    @click.stop="openDeleteModal(item)"
                >
                  {{ msg('Delete') }}
                </b-button>
              </b-card-footer>
            </b-card>
          </b-col>
        </b-row>

        <!-- Busy / Empty -->
        <div v-if="loading" class="text-center my-4">
          <b-spinner class="mx-1"/>
          <strong>{{ msg('Loading') }}â€¦</strong>
        </div>
        <b-alert v-else-if="!buildings.length" variant="info" class="my-4 text-center">
          {{ msg('No results found') }}
        </b-alert>
      </b-container>

      <!-- Paginator -->
      <b-card-body class="pt-0 px-3 pb-3">
        <div class="d-flex justify-content-center align-items-center">
          <b-pagination
              v-model="page.currentPage"
              :total-rows="page.total"
              :per-page="page.amount"
              first-number last-number
              @input="refresh"
              class="mb-0"
          />
          <span class="ml-3"><strong>{{ msg('Total') }}</strong> {{ page.total }}</span>
        </div>
      </b-card-body>
    </b-card>
    <b-modal
        no-fade
        v-model="dialogs.building"
        size="lg"
        ref="building-modal"
        id="building-modal"
        :hide-footer="true"
        no-close-on-backdrop
        centered
        hide-header
        modal-class="building-create-wizard-modal"
        content-class="building-create-wizard-content shadow-none"
        @shown="onBuildingModalShown"
    >
      <building-create-wizard
          ref="buildingWizard"
          @cancel="closeBuildingWizard"
          @done="onBuildingWizardDone"
      />
    </b-modal>

    <b-modal
        id="confirm-delete-modal"
        ref="confirmModal"
        :title="msg('Confirm deletion')"
        @ok="confirmDelete"
        :ok-title="msg('Yes, Delete')"
        ok-variant="danger"
        :cancel-title="msg('cancel')"
        size="md"
        centered
    >
      <div class="text-center">
        <p>{{msg('Are you sure you want to permanently remove this building?')}}</p>
        <b-badge v-if="buildingToDelete!=null" variant="primary" class="p-2">
          {{ buildingToDelete.company + ' - ' + buildingToDelete.address }}
        </b-badge>
      </div>
    </b-modal>

    <b-modal ref="modalRef" size="lg" :title="msg('Listings from external platform that arent currently in your system')"
             :hide-footer="true">
      <div v-if="fetchedListingMap==null || fetchedListingMap.length === 0">Loading...</div>
      <template v-else>
        <p>{{msg('Pick an owner')}}</p>
        <client-picker class="mb-2" v-model="ownerId" is-owner/>

        <div class="mb-2" v-for="(value, key) in fetchedListingMap" :key="key">
          <b-button :disabled="ownerId==null"   variant="success" size="sm"
                    @click="importBuildingFromExternalPlatform(key)">Import
          </b-button>
          <span class="mx-1">{{ value }}</span>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import BuildingCreateWizard from './BuildingCreateWizard'
import BreadcrumbButtons from "@/components/widgets/breadcrumbButtons.vue";
import ClientPicker from "@/components/components/picker/clientPicker.vue";
import PageHero from '@/components/PageHero.vue';

export default {
  name: 'Buildings',
  components: {
    PageHero,
    ClientPicker,
    BreadcrumbButtons,
    BuildingCreateWizard
  },
  data() {
    return {
      fetchedListingMap: null,
      ownerId: null,
      fetchListLoading: false,
      hostawayBuid: null,
      excelUrlBuildings: "",
      buildingToDelete:null,
      excelUrlClients: "",
      file: null,
      fileClient: null,
      loading: true,
      amount: 10,
      bankList: [],
      buildings: [],
      fields: [],
      buildingId: null,
      buid: null,
      filter: {
        like: {search: '', name: "", shortDescription: ""},
        eq: {type: "", realEstateArea: {}},
        lte: {},
        gte: {},
        in: {activeBanksIds: []}
      },
      sort: {
        by: 'updatedDate',
        desc: true,
        direction: 'desc'
      },
      statusVariants:
          {"NEW": "primary", "ACTIVE": "success", "EXPOSE": "warning", "DISABLED": "danger"},

      page: {
        amount: 10,
        currentPage: 1,
        total: 0
      },
      dialogs: {building: false},
      addressName: null,
      infoModal: {
        id: 'info-modal',
        title: '',
        content: ''
      },
      featureInfoModal: {
        id: 'feature-modal',
        title: '',
        content: ''
      },
      //Listeners
      listeners: {
        refresh: () => {
        }
      }

    }
  },
  watch: {
    filter: {
      deep: true,
      handler() {
        this.refresh()
      }
    },
    file: {
      handler() {
        this.uploadFile()
      }
    }, fileClient: {
      handler() {
        this.uploadFileClient()
      }
    }
  },
  computed: {
    ...mapGetters('data', ['getOrganizationWebSite', 'getRealEstatesWebSite']),
    ...mapGetters('data', ['getUserFullName', 'getUserAcronyms']),
    ...mapGetters('data', ['getAllUsers', 'getUsersInTeam', 'getUserRole', 'getRoles', 'getRoleName']),
    ...mapGetters('translator', ['msg']),
    ...mapGetters('building', ['allStatuse']),
    ...mapGetters('data', ['getAllBranches']),
    allBranches() {
      return Object.values(this.getAllBranches)
          .filter(branch =>
              branch.externalApiType !== null &&
              (branch.externalApiType === 'APALEO' || branch.externalApiType === 'CLOUDBEDS')
          );
    },
    allBranchesForUpload() {
      return Object.values(this.getAllBranches);
    },
    allStatuses() {
      return Object.values(this.allStatuse)
    },
    allBanks() {
      return this.bankList
          .map(bank => ({
            id: bank.id,
            name: (bank.name)
          }))
    },

    allbuildings() {
      return this.buildings
    }
  },
  created() {
    let $this = this;
    Promise.all([this._loadBankList({amount: 9999}).then(ans => {
      $this.bankList = ans["Banks"];

    })]).finally(() => {
          if (typeof $this.building !== 'undefined') {
            $this.currentBankList = $this.building.activeBanks;
          }
        }
    )
    this.setFields();
    this.refresh()
    this.$root.$on('crm::branch-updated', (this.listeners.refresh = () => {
      $this.refresh()
    }))
  },
  mounted() {
    this.$nextTick(() => {
      window.scrollTo(0, 0);
      const el = document.querySelector('.content-body') || document.documentElement;
      if (el && el.scrollTop !== undefined) el.scrollTop = 0;
    });
  },
  beforeDestroy() {
    this.$root.$off('crm::branch-updated', this.listeners.refresh)
  },
  methods: {
    ...mapActions('building', ['fetchAllBuildingsFromExternal','fetchBuildingFromExternalPlatform','getAllBuildings','deleteBuilding', 'copySuccess', 'getExcelTemplateUrl', 'getExcelTemplateUrlClients']),
    ...mapActions('building', {_uploadExcel: 'uploadExcel', _uploadExcelClient: 'uploadExcelClient'}),
    ...mapActions('bank', {
      _loadBankList: 'getAllBanks'
    }),
    fetchListFromExternal() {
      this.fetchListLoading = true;
      this.fetchAllBuildingsFromExternal({buid: this.hostawayBuid})
          .then((ans) => {
            this.fetchedListingMap = ans;
            this.$refs.modalRef.show();
            this.fetchListLoading = false;
          })
          .catch(() => this.fetchListLoading = false)
    },
    importBuildingFromExternalPlatform(channelId) {
      this.fetchListLoading = true;
      this.fetchBuildingFromExternalPlatform({
        buid: this.hostawayBuid, channelId: channelId,ownerId: this.ownerId
      })
          .then((ans) => {
            this.fetchListFromExternal();

          })
    },
    dismissAllPopovers() {
      this.$root.$emit('bv::hide::popover')
    },
    openDeleteModal(item) {
      this.buildingToDelete = item
      this.$nextTick(() => {
        this.$refs.confirmModal.show()
      })
    },

    confirmDelete() {
      let $this = this
      this.deleteBuilding(this.buildingToDelete.id).then(() => {
        this.refresh()
      }, (error) => {
        $this.error = error
      })

      this.buildingToDelete = null
      this.$nextTick(() => {
        this.$refs.confirmModal.hide()
      })
    },
    uploadFile() {
      let $this = this
      if (this.file == null)
        return;

      let paramMap = {"buid": this.buid}
      this._uploadExcel({file: this.file, params: paramMap}).finally(() => $this.refresh());

    },
    uploadFileClient() {
      let $this = this
      console.log('uploadExcelClient')
      if (this.fileClient == null)
        return;

      let paramMap = {"buildingId": this.buildingId}
      this._uploadExcelClient({fileClient: this.fileClient, params: paramMap}).finally(() => $this.refresh());

    },
    resetFile() {
      this.file = null;
    },
    resetFileClients() {
      this.fileClient = null;
    },
    downloadExcelTemplate() {
      console.log("building excel template url :", this.excelUrlBuildings)
      window.open(this.excelUrlBuildings, '_blank', 'location=yes,height=570,width=520,scrollbars=yes,status=yes');
    },
    downloadExcelTemplateClients() {
      console.log("client excel template url :", this.excelUrlClients)
      window.open(this.excelUrlClients, '_blank', 'location=yes,height=570,width=520,scrollbars=yes,status=yes');
    },

    onCopy: function (e) {
      this.copySuccess(e.text)
    },
    onError: function (e) {
      alert('Failed to copy the text to the clipboard')
    },

    setFields() {
      let $this = this
      this.fields = [
        {
          key: 'active',
          label: $this.msg('Active'),
          sortable: true
        }, {
          key: 'updatedDate',
          label: $this.msg('Updated at'),
          sortable: true
        },
        {
          key: 'attachments',
          label: $this.msg('Main image'),
          sortable: true,
          active: true,
        },
        {
          key: 'company',
          label: $this.msg('Company'),
          sortable: true
        },
        {
          key: 'address',
          label: $this.msg('Address'),
          sortable: true
        },
        {
          key: 'buildingInvoices',
          label: $this.msg('Open Invoices'),
          sortable: true,
          active: true,
        },
        {
          key: 'propertyIds',
          label: $this.msg('units'),
          sortable: true,
          active: true,
        },
        {
          key: 'status',
          label: $this.msg('Status'),
          sortable: true
        },


        {
          key: 'offerTemplateIds',
          label: $this.msg('Template'),
          sortable: true,
          active: true,
        },

        {
          key: 'userIds',
          label: $this.msg('Users'),
          sortable: true,
          active: true,
        },


      ]
    },
    info(item, index, button) {
      this.infoModal.title = `Row index: ${index}`
      this.infoModal.propertyId = item.id;
      this.addressName = item.address != null ? item.address : "Die Addresse ist leer";
      this.$root.$emit('bv::show::modal', this.infoModal.id, button)
    },
    infoFeature(item, index, button) {
      this.featureInfoModal.title = `Row index: ${index}`
      this.featureInfoModal.propertyId = item.id;
      this.addressName = item.address != null ? item.address : "Die Addresse ist leer";
      this.$root.$emit('bv::show::modal', this.featureInfoModal.id, button)
    },
    copyId(id) {
      console.log("the id copied was: ", id)
    },
    resetInfoModal() {
      this.$root.$emit('bv::hide::modal', this.infoModal.id)
    },
    resetFeatureInfoModal() {
      this.$root.$emit('bv::hide::modal', this.featureInfoModal.id)
    },
    refresh() {
      let $this = this
      this.loading = true;
      this.getAllBuildings({
        page: $this.page.currentPage,
        amount: $this.page.amount,
        filter: $this.filter,
        sortcolumn: 'updatedDate',
        sortby: 'desc',
      }).then(this.onBuildingsRetrieve, (error) => $this.error = error)

      this.getExcelTemplateUrl().then((url) => $this.excelUrlBuildings = url);
      this.getExcelTemplateUrlClients().then((url) => $this.excelUrlClients = url);

    },
    onBuildingsRetrieve(data) {
      this.page = {
        amount: data['Amount'],
        total: data['Total'],
        currentPage: data['Page']
      };
      this.sort = {
        by: data["sortColumn"],
        direction: data["sortOrder"]
      }
      this.buildings = data["Buildings"];
      this.loading = false;
    },
    onBuildingSelect(id) {
      this.selected = id
      if (id === 0) {
        this.dialogs.building = true
      }
    },
    onSort(data) {
      this.sort.by = data.sortBy;
      this.sort.direction = data.sortDesc ? "desc" : "asc";
      this.refresh();
    },
    onRowClick(building) {
      this.$router.push(`/building/edit/${building.id}`);
    },

    onBuildingModalShown() {
      this.$nextTick(() => {
        if (this.$refs.buildingWizard && this.$refs.buildingWizard.reset) {
          this.$refs.buildingWizard.reset()
        }
      })
    },
    closeBuildingWizard() {
      this.dialogs.building = false
    },
    onBuildingWizardDone(payload) {
      if (payload && payload.id != null) {
        this.selected = payload.id
      }
      this.dialogs.building = false
      this.refresh()
    },
    getBadgeVariant(count) {
      if (count === 1) {
        return 'warning'; // Green
      } else if (count >= 2) {
        return 'danger'; // Orange
      }
      // Default to primary if count is 0 or undefined
      return 'success';
    },
    getCountOfOpenInvoices(invoices) {
      if (invoices == null) {
        return 0
      }
      let count = 0;
      for (const invoice of invoices) {
        if (invoice.invoiceStatus === 'OPEN') {
          count++;
        }
      }
      return count;
    },
  }
}
</script>

<style>
.custom-row-inactive {
  background-color: rgba(131, 36, 36, 0.62) !important; /* Light Red */
  color: white !important; /* Dark Red Text */
}

.building-card {
  border: none;
  border-radius: 1rem;
  overflow: hidden;
  background: #fff;
  transition: transform .3s, box-shadow .3s;
  perspective: 800px;
}

.building-card:hover {
  transform: translateY(-6px) rotateX(1.5deg) rotateY(1.5deg);
  box-shadow: 0 16px 32px rgba(0, 0, 0, 0.12), 0 24px 48px rgba(0, 0, 0, 0.08);
}

/* Highlight active */
.active-highlight {
  border: 2px solid #c2aa8b;
}

.not-active-highlight {
  border: 2px solid #d3310e;
}

/* 3D shadow */
.shadow-3d {
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1), 0 12px 24px rgba(0, 0, 0, 0.06);
}

/* Image */
.card-image-wrapper {
  width: 100%;
  height: 250px;
  overflow: hidden;
}

.card-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.rounded-top {
  border-top-left-radius: 3rem;
  border-top-right-radius: 3rem;
  border-bottom-right-radius: 1rem;
  border-bottom-left-radius: 1rem
}

.image-placeholder {
  background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%);
  min-height: 250px;
}

/* Text */
.company-name {
  font-size: 1.1rem;
  font-weight: 600;
}

.address {
  font-size: 1.5rem;
  color: #555;
}

/* List items */
.list-unstyled li {
  margin-bottom: .5rem;
  font-size: 0.9rem;
}

/* Badges */
.status-badge {
  font-size: .75rem;
}

b-badge {
  line-height: 1;
}

/* Paginator */
.paginator-wrapper .pagination {
  margin: 0;
}

.paginator-wrapper span {
  font-size: .9rem;
}

/* Import card - compact combined uploads */
.import-card {
  border: 1px solid #e8e8e8;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}
.import-card-inner {
  display: flex;
  flex-wrap: wrap;
  gap: 1.25rem 2rem;
  align-items: flex-start;
}
.import-section {
  flex: 1;
  min-width: 280px;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
.import-section-label {
  font-size: 0.875rem;
  font-weight: 600;
  color: #5e5873;
  display: flex;
  align-items: center;
}
.import-section-controls {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  align-items: center;
}
.import-section-controls .import-select {
  min-width: 140px;
  max-width: 180px;
}
.import-section-controls .import-file {
  max-width: 200px;
}
.import-section-controls .import-file .custom-file-label::after {
  padding: 0.25rem 0.5rem;
  font-size: 0.8rem;
}

/* Responsive tweaks */
@media (max-width: 576px) {
  .card-image-wrapper {
    height: 200px;
  }

  .company-name {
    font-size: 1.25rem;
  }

  .address, .list-unstyled li {
    font-size: 1rem;
  }

  .import-card-inner {
    flex-direction: column;
    gap: 1rem;
  }
  .import-section {
    min-width: 100%;
  }
  .import-section-controls .import-select,
  .import-section-controls .import-file {
    max-width: 100%;
  }
}

.building-create-wizard-modal .modal-dialog {
  max-width: 640px;
  width: calc(100% - 1.5rem);
  margin: 1rem auto;
}
.building-create-wizard-modal .modal-content {
  border-radius: 12px;
  overflow: hidden;
}
.building-create-wizard-modal .building-create-wizard-content {
  padding: 1rem 1.25rem 1.25rem;
}
@media (max-width: 575px) {
  .building-create-wizard-modal .modal-dialog {
    margin: 0.5rem;
    width: calc(100% - 1rem);
  }
}
</style>
